import { __rest } from 'tslib';
import React from 'react';
import { StyledQuotedText, StyledText } from './Text.styles.mjs';

const TextComponent = (_a) => {
    var { children, tag, quoted } = _a, props = __rest(_a, ["children", "tag", "quoted"]);
    return quoted ? (React.createElement(StyledQuotedText, Object.assign({ tag: tag }, props), children)) : (React.createElement(StyledText, Object.assign({ tag: tag }, props), children));
};

export { TextComponent as default };
//# sourceMappingURL=Text.mjs.map
